import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import carIocn from "../../assets/images/car.png";
import { Link } from "react-router-dom";
import img1 from "../../assets/images/noimage.jpg";
import axios from "axios";
import { MyApi } from "../../MyApi";
export default function OurCars() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(
          MyApi.BASE_URL + MyApi.Our_Cars,
          { headers: { Authorization: MyApi.SECRET_KEY } }
        );

        if (res.data?.status) {
          setServices(res.data.data || []);
        }
      } catch (error) {
        console.error("Expert services API error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  if (loading) {
    return <p className="text-center py-5">Loading services...</p>;
  }

  return (
    <div>
      <div className="services-one pt-0"> 
        <div className="services-one__shape-2"></div>
        {/* your actual content here */}
        <Container>
          <div className="section-title mb-4 mt-5">
            <img src={carIocn} alt="" />
            <h2>Our Cars For Rental</h2>
            <span>
              Choose From Our Wide Range Of Well-Maintained Vehicles For All
              Your Travel Needs.
            </span>
          </div>
          <div className="servi_bx">
            <Row className="g-3">
            {services.length > 0 ? (
              services.map((item, index) => {
                // ✅ VERY IMPORTANT NULL CHECK
                if (!item?.product || !item?.parent_category) {
                  return null; // skip broken record
                }

                const product = item.product;
                const category = item.parent_category;

                return (
              <Col md={4} xs={6}>
                <div className="custom-figure">
                  <Link to={`/${category.categoryurl}/${product.producturl}`}>
                     <img
                          src={product.image_url || img1}
                          alt={product.productname}
                          className="img-fluid"
                          onError={(e) => (e.target.src = img1)}
                        />
                  </Link>
                  <Link  to={`/${category.categoryurl}/${product.producturl}`} className="figcaption">
                    <h3>{product.productname}</h3>
                    <p>{product.productheading}</p>
                  </Link>
                    <a
      href={`https://wa.me/919569234541?text=${encodeURIComponent(
        `Hi, I want details about ${product.productname}.
        
Product Link: ${window.location.origin}/${category.categoryurl}/${product.producturl}`
      )}`}
      target="_blank"
      rel="noopener noreferrer"
      className="btn btn-danger mt-2 position-absolute top-0   z-3"
      style={{right:10}}
    >
      Book Now
    </a>
                  
                
                </div>
              </Col>
               );
              })
            ) : (
              <Col>
                <p className="text-center">No services found</p>
              </Col>
            )}
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
}
